import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AppProviders } from "./interface/contexto/AppProviders.js";

import Login from "./interface/pages/login/login.js";

import "./core/events/initializeDomainEventHandlers.js"

import Navbar from "./interface/componentsUI/estructura/navegacion/navbar.js";
import FooterNavbar from "./interface/componentsUI/estructura/footer/footer.js";

import TemplateCaja from "./interface/modulos/caja/template/TemplateCaja.js";
import TemplateVenta from "./interface/modulos/pedidos/plantilla/TemplateVenta.js";
import TemplatePagos from "./interface/modulos/ventas/plantilla/TemplatePago.js";
import TemplateInventario from "./interface/modulos/inventario/templatePasos/TemplateInventario.js";
import TemplateCuenta from "./interface/modulos/tienda/template/TemplateTienda.js";
import TemplateGastos from "./interface/modulos/gastos/template/TemplateGastos.js";
const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogin = (success) => {
    if (success) setIsAuthenticated(true);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
  };

  return (
    <AppProviders>
      <Router>
        {isAuthenticated && (
          <>
            <Navbar onLogout={handleLogout} />
            <FooterNavbar onLogout={handleLogout} />
          </>
        )}

        <Routes>
          {/* LOGIN */}
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to="/caja" />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />

          {/* RUTAS PROTEGIDAS */}
          <Route
            path="/caja"
            element={
              isAuthenticated ? <TemplateCaja /> : <Navigate to="/" />
            }
          />
          <Route
            path="/ventas"
            element={
              isAuthenticated ? <TemplateVenta /> : <Navigate to="/" />
            }
          />
          <Route
            path="/pagos"
            element={
              isAuthenticated ? <TemplatePagos /> : <Navigate to="/" />
            }
          />

          <Route
            path="/gastos"
            element={
              isAuthenticated ? <TemplateGastos /> : <Navigate to="/" />
            }
          />
          <Route
            path="/inventario"
            element={
              isAuthenticated ? <TemplateInventario /> : <Navigate to="/" />
            }
          />
          <Route
            path="/panelTienda"
            element={
              isAuthenticated ? <TemplateCuenta /> : <Navigate to="/" />
            }
          />

          {/* CUALQUIER OTRA RUTA */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </AppProviders>
  );
};

export default App;
